export const USER_SIGNIN = 'USER_SIGNIN' // 登录成功
export const USER_INFO = 'USER_INFO' // 获取用户信息
export const USER_SIGNOUT = 'USER_SIGNOUT' // 退出登录

export const USER_EDIT = 'USER_EDIT' // 用户修改

export const GET_POL = 'GET_POL' // 获取起运港
export const SELECT_POL = 'SELECT_POL' // 选择起运港
export const SELECT_POD = 'SELECT_POD' // 选择起运港
export const FCL_EDIT = 'FCL_EDIT' // 选择起运港
export const AIR_EDIT = 'AIR_EDIT' // 选择起运港
// order
export const BOOKING = 'BOOKING'
export const GET_BOOKING = 'GET_BOOKING'
export const GET_CITYLIST = 'GET_CITYLIST' // 获取城市
export const CITYLIST = 'CITYLIST' // 获取城市
export const CITY = 'CITY'
export const SET_CONSIGN = 'SET_CONSIGN'
export const GET_CONSIGN = 'GET_CONSIGN' // 获取订单

// hotPort
export const GET_HOTPORT = 'GET_HOTPORT' // 获取订单
export const GET_LINEAREA = 'GET_LINEAREA' // 获取订单
